
export const MovementPatternConstant = {
    Table: {
        PRIORITY: "Priority",
        CHARGE_ON_COMPANY: "Charge-On Company",
        PATTERN_TYPE: "Pattern Type",
        NO_LIFT: "Qty",
        ACTIVE_IND: "Active Ind.",
        SEQ: "Seq",
        CON_STATUS: "Container Status",
        MOVEMENT_IND: "Movement Indicator",
        OT_FROM: "OT Charge (From)",
        OT_TO: "OT Charge (To)",
    },
    Title: {
        CATEGORY: "Charge",
        TITLE: "Rehandling / Cancel Shipment Movement Pattern",
        DTL_TITLE: "Shipment Movement Pattern Detail List",
    },
}
export const movementPatternRequiredFieldList: string[] = [
    'patternType',
    'noOfLift',
    'activeInd',
];
export const movementPatternDtlRequiredFieldList: string[] = [
    'cntrStatus',
    'movementCode',
    'fromOtChargeInd',
    'toOtChargeInd',
];